module.exports = __webpack_public_path__ + "static/media/qrcode.b33652e9.png";